// Contingut del lloc web de Karamiko (en català)

export const NAV_LINKS = [
  { id: "espectacles", label: "Espectacles" },
  { id: "valors", label: "Valors" },
  { id: "qui-som", label: "Qui som" },
  { id: "contacte", label: "Contacte" },
];

export const HERO = {
  kicker: "Animal Soul",
  title: "Despertem la imaginació de les més petites i els més petits",
  subtitle:
    "Espectacles i tallers fets a mà, en català i de proximitat. Des de Lleida, sembrem valors i fem créixer la imaginació.",
  ctaPrimary: "Descobreix els espectacles",
  ctaSecondary: "Qui som",
};

export const EMAIL = "karamikoanimalsoul@gmail.com";

export const PHONES = [
  { name: "Albert", number: "625 19 44 56" },
  { name: "Saray", number: "653 22 36 51" },
];

export const INSTAGRAM = { handle: "@karamiko_animalsoul", url: "https://instagram.com/karamiko_animalsoul" };

// L'adreça mostrada s'adapta sola al domini on està servida la web (karamiko.cat quan estigui connectat)
export const WEBSITE = {
  get url() {
    return typeof window !== "undefined" ? window.location.origin : "https://karamiko.cat";
  },
  get label() {
    return typeof window !== "undefined" ? window.location.host : "karamiko.cat";
  },
};

export const SHOWS = [
  {
    id: "glup-glup",
    title: "glup-glup",
    age: "0 – 3 anys",
    tag: "Espai sensorial",
    image: "/show-glupglup.jpg",
    description:
      "Us convidem a capbussar-vos en una bombolla marina de calma, llum i joc. Apaguem els llums de la sala per encendre un fons del mar màgic, ple de reflexos d'aigua, meduses que ballen i criatures marines amigables. Amb titelles marins tovets, textures per tocar i una banda sonora d'aigua, els nadons es converteixen en petites exploradores i petits exploradors al seu ritme.",
    bullets: ["Espai sensorial per a nadons", "Titelles marins i textures", "Carpa-bombolla amb llums i projeccions"],
  },
  {
    id: "cinc-postals",
    title: "Cinc postals",
    age: "3 – 6 anys",
    tag: "Contacontes participatiu",
    image: "/show-cincpostals.jpg",
    description:
      "Una persona viatgera arriba amb una maleta que guarda cinc postals molt especials. A cada postal hi viu un animal amb alguna cosa important per explicar: cinc contes recollits als cinc continents, cinc trobades inesperades i cinc petits tresors de saviesa. El públic tria quins contes vol escoltar, en un espectacle de narració oral amb objectes, música, titelles i molt d'humor.",
    bullets: ["El públic tria els contes", "Saviesa animal dels 5 continents", "Narració oral amb titelles i música"],
  },
];

export const VALUES = [
  {
    id: "feminisme",
    icon: "Sparkles",
    title: "Feminisme",
    text: "Narratives que trenquen estereotips, llenguatge inclusiu i coeducació. Una mirada interseccional que celebra la diversitat.",
  },
  {
    id: "ecologisme",
    icon: "Leaf",
    title: "Ecologisme",
    text: "Escenografies i vestuari amb materials reciclats i de proximitat, residu mínim i missatges de respecte per la natura.",
  },
  {
    id: "arrelament",
    icon: "MapPin",
    title: "Arrelament al territori",
    text: "Compromís amb Lleida i el seu entorn. Col·laboració local i proximitat amb el públic.",
  },
  {
    id: "catala",
    icon: "MessageCircle",
    title: "Català",
    text: "El català és la nostra llengua vehicular: espectacles, tallers i comunicació íntegrament en català, amb gust per la paraula.",
  },
  {
    id: "conciliacio",
    icon: "Heart",
    title: "Conciliació familiar",
    text: "Un model de feina que respecta els ritmes de la vida i la criança, amb horaris amables per a artistes i famílies.",
  },
];

export const TEAM = [
  {
    id: "saray",
    name: "Saray Claveria",
    role: "Actriu · creadora · pedagoga",
    text: "Aporta una visió artística profunda i una llarga trajectòria en creació escènica i pedagogia teatral amb infants.",
  },
  {
    id: "albert",
    name: "Albert Garcia",
    role: "Actor · creador · director · gestor",
    text: "Coneix el sector de dalt a baix: creació, direcció d'espectacles i gestió cultural amb companyies de referència.",
  },
];

export const ABOUT = {
  kicker: "Qui som",
  title: "Una companyia de teatre nascuda de la passió pel teatre i la vida",
  paragraphs: [
    "Karamiko és una companyia de teatre fruit de la trajectòria de la Saray i l'Albert. Neix de l'amor pel teatre i de la convicció de construir un camí propi, respectuós amb els ritmes de la vida i la família.",
    "Fem un teatre d'essència, artesanal i de proximitat: poètica de la simplicitat, cura artesanal i compromís amb el territori. Creiem que el teatre és una eina poderosa per connectar amb l'essència humana i la natura.",
  ],
};

export const CONTACT = {
  kicker: "Som ben a prop",
  title: "Parlem?",
  text: "Voleu portar Karamiko a la vostra escola, biblioteca, festa major o centre cultural? Escriviu-nos i ens posarem en marxa.",
};
